import { getReq } from './api';

export type InfoOption = {
  value: string;
  display_name: string;
};

export type EmploymentTypeInfoOption = InfoOption & {
  // Deprecated employment types can still be assigned to officials, but can't be selected
  deprecated: boolean;
};

export type Info = {
  employment_types: EmploymentTypeInfoOption[];
  uncleared_reasons: InfoOption[];
};

export const getInfo = async (
  accessToken: string
): Promise<{ data?: Info; error?: string }> => {
  return getReq<Info>('/info', accessToken);
};
